import { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import {
  ConfigProvider,
  Space,
  Table,
  Tag,
  Input,
  Flex,
  InputNumber,
  Button,
  Alert,
  message,
  DatePicker,
} from "antd";

import { API, URL } from "@/config/api";

import dayjs from "dayjs";

import { ICONS } from "@/assets";
import CustomModal from "@/components/CustomModal";
const { TextArea } = Input;

import { ColumnTransaksiInhouse } from "../../../library/FormColumn";

// import data from "./data";
// import data from "./dataTrx.json";

import jsPDF from "jspdf";
import "jspdf-autotable";

import { createStyles } from "antd-style";
const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const ReportInhousePage = () => {
  const { styles } = useStyle();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  console.log("selectedData", data);

  const extendedColumn = [...ColumnTransaksiInhouse.columns];

  const [messageApi, contextHolder] = message.useMessage();
  const errorMsg = () => {
    messageApi.open({
      type: "error",
      content: "Data is empty",
    });
  };

  const getData = async () => {
    try {
      setLoading(true);
      const response = await API.get(URL.TRX_INHOUSE);
      setData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      message.error("Data failed to fetch!");
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const exportPDF = () => {
    console.log(data);
    if (data != "") {
      const doc = new jsPDF();

      // Ambil header dari kolom tabel Ant Design
      const headers = ColumnTransaksiInhouse.columns.map((col) => col.title);

      // Ambil data dari `dataSource`
      const body = data.map((row) =>
        ColumnTransaksiInhouse.columns.map((col) => row[col.dataIndex])
      );

      // Gunakan `autoTable` untuk membuat PDF
      doc.autoTable({
        head: [headers],
        body: body,
      });

      // Simpan file PDF
      doc.save("Laporan Keuangan.pdf");
    } else {
      errorMsg();
      console.log("error");
    }
  };

  // const exportToExcel = async () => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Inhouse");

  //   worksheet.columns = [
  //     { header: "Tanggal", key: "tanggal", width: 15 },
  //     { header: "No. Akun", key: "noAcc", width: 15 },
  //     { header: "Nama Akun", key: "nameAcc", width: 25 },
  //     { header: "Keterangan", key: "keterangan", width: 60 },
  //     {
  //       header: "Debet",
  //       key: "debet",
  //       width: 20,
  //       style: { numFmt: "Rp #,##0.00;[Red]-Rp #,##0.00" },
  //     },
  //     {
  //       header: "Kredit",
  //       key: "kredit",
  //       width: 20,
  //       style: { numFmt: "Rp #,##0.00;[Red]-Rp #,##0.00" },
  //     },
  //     {
  //       header: "Saldo",
  //       key: "saldo",
  //       width: 20,
  //       style: { numFmt: "Rp #,##0.00;[Red]-Rp #,##0.00" },
  //     },
  //   ];

  //   data.forEach((item) => {
  //     worksheet.addRow(item);
  //   });

  //   worksheet.getRow(1).eachCell((cell) => {
  //     (cell.font = { bold: true }),
  //       (cell.alignment = { vertical: "middle", horizontal: "center" }),
  //       (cell.fill = {
  //         type: "pattern",
  //         pattern: "solid",
  //         fgColor: { argb: "FFD700" }, // Gold color
  //       });
  //   });

  //   // Adjust the style for numeric cells
  //   worksheet.eachRow((row, rowIndex) => {
  //     if (rowIndex > 1) {
  //       row.getCell(5).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00"; // Debet
  //       row.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00"; // Kredit
  //       row.getCell(7).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00"; // Saldo
  //     }
  //   });

  //   // Generate Excel file
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   // Save the file
  //   saveAs(blob, "DataReportInhouse.xlsx");
  // };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Buku Besar");

    // Tambahkan header utama
    worksheet.mergeCells("A1:H1");
    const header1 = worksheet.getCell("A1");
    header1.value = "BUKU BESAR";
    header1.font = { bold: true, size: 24 };
    header1.alignment = { horizontal: "center", vertical: "middle" };
    header1.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };

    worksheet.mergeCells("A2:H2");
    const header3 = worksheet.getCell("A2");
    header3.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ffffff" }, // white background
    };

    // Tambahkan sub-header dengan tanggal
    worksheet.mergeCells("A3:H3");
    const header2 = worksheet.getCell("A3");
    header2.value = "30-Jan-25";
    header2.font = { bold: true, size: 32 };
    header2.alignment = { horizontal: "center", vertical: "middle" };
    header2.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };

    worksheet.getRow(4).height = 25;

    // Tambahkan header kolom
    const headers = [
      "TANGGAL",
      "NO. BUKTI",
      "NOMOR AKUN",
      "NAMA AKUN",
      "KETERANGAN",
      "DEBIT",
      "KREDIT",
      "SALDO",
    ];
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
      cell.value = header;
      cell.font = { bold: false, size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    data.forEach((item, rowIndex) => {
      const row = worksheet.getRow(5 + rowIndex); // Data dimulai dari baris ke-4
      row.getCell(1).value = item.tgl;
      row.getCell(2).value = item.noBukti;
      row.getCell(3).value = item.noAcc;
      row.getCell(4).value = item.nameAcc;
      row.getCell(5).value = item.keterangan;
      row.getCell(6).value = item.debet;
      row.getCell(7).value = item.kredit;
      row.getCell(8).value = item.saldo;

      row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(3).alignment = { horizontal: "center", vertical: "middle" };

      // Format untuk nilai angka (Debet, Kredit, Saldo)
      row.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
      row.getCell(7).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
      row.getCell(8).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
    });

    // Atur lebar kolom
    worksheet.columns = [
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 25 },
      { width: 60 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "Laporan Buku Besar.xlsx");
  };

  return (
    <div>
      {contextHolder}

      <h1 className="text-4xl font-semibold mb-8 text-center">
        Report Transaksi Inhouse
      </h1>

      <div className="flex justify-between">
        <div className="flex gap-4">
          <Button
            size="large"
            // type="primary"
            onClick={exportPDF}
            className=" bg-red-500 text-white py-2 px-4 rounded-md mb-4"
          >
            Export PDF
          </Button>

          <Button
            size="large"
            // type="primary"
            onClick={exportToExcel}
            className="bg-green-600 text-white py-2 px-4 rounded-md mb-4"
          >
            Export Excel
          </Button>
        </div>
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
              // borderColor: "#000",
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <Table
          className={styles.customTable}
          columns={extendedColumn}
          dataSource={data}
          size="middle"
          scroll={{
            x: "max-content",
            // y: 55 * 5,
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default ReportInhousePage;
